<p-toast></p-toast>
<p-card styleClass="p-card-shadow">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar>
        <p-table #miSurvey [value]="vendorMiArea"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'vendorName',
		'ProgrammeName',
		'Verified_App_Area',
		'Pending_App_Area',
		'Incomplete_App_Area',
		'Rejected_App_Area',
		'changeRequest_App_Area',
		'Total_App_Area',
        'TargerArea'
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'VENDOR_MI_AREA_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <th pSortableColumn="vendorName">{{'VENDOR_NAME'| translate}}
                    <p-columnFilter type="text" field="vendorName" display="menu"></p-columnFilter>
                    <p-sortIcon field="vendorName"></p-sortIcon>
                </th>
                <th pSortableColumn="ProgrammeName">{{'PROGRAMME_NAME'| translate}}
                    <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
                    <p-sortIcon field="ProgrammeName"></p-sortIcon>
                </th>
                <th pSortableColumn="Verified_App_Area">{{'VERIFIED_APP_AREA'| translate}}
                    <p-columnFilter type="text" field="Verified_App_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Verified_App_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="Pending_App_Area">{{'PENDING_APP_AREA'| translate}}
                    <p-columnFilter type="text" field="Pending_App_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Pending_App_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="Incomplete_App_Area">{{'INCOMPLETE_APP_AREA'| translate}}
                    <p-columnFilter type="text" field="Incomplete_App_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Incomplete_App_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="Rejected_App_Area">{{'REJECTED_APP_AREA'| translate}}
                    <p-columnFilter type="text" field="Rejected_App_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Rejected_App_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="changeRequest_App_Area">{{'CHANGEREQUEST_APP_AREA'| translate}}
                    <p-columnFilter type="text" field="changeRequest_App_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="changeRequest_App_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="Total_App_Area">{{'TOTAL_APP_AREA'| translate}}
                    <p-columnFilter type="text" field="Total_App_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Total_App_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="TargerArea">{{'TARGET_AREA'| translate}}
                    <p-columnFilter type="text" field="TargerArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="TargerArea"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vendorMiArea>
            <tr>
                <td>{{vendorMiArea.vendorName}}</td>
                <td>{{vendorMiArea.ProgrammeName}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(vendorMiArea.Vendor_Code,'Approved',vendorMiArea.vendorName,vendorMiArea.ProgrammeName)">{{vendorMiArea.Verified_App_Area}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(vendorMiArea.Vendor_Code,'Pending',vendorMiArea.vendorName,vendorMiArea.ProgrammeName)">{{vendorMiArea.Pending_App_Area}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(vendorMiArea.Vendor_Code,'Incomplete',vendorMiArea.vendorName,vendorMiArea.ProgrammeName)">{{vendorMiArea.Incomplete_App_Area}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_rejected(vendorMiArea.Vendor_Code,'Rejected',vendorMiArea.vendorName,vendorMiArea.ProgrammeName)">{{vendorMiArea.Rejected_App_Area}}</a></td>
                <td>{{vendorMiArea.changeRequest_App_Area}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_totalApp(vendorMiArea.Vendor_Code,'All',vendorMiArea.vendorName,vendorMiArea.ProgrammeName)">{{vendorMiArea.Total_App_Area}}</a></td>
                <td>{{vendorMiArea.TargerArea}}</td>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td></td>
                <td >{{verfAppArea | number:'1.0-2'}}</td>
                <td >{{pendingArea | number:'1.0-2'}}</td>
                <td >{{incompleteAppArea | number:'1.0-2'}}</td>
                <td >{{rejectedAppArea | number:'1.0-2'}}</td>
                <td >{{changeRequestAppArea | number:'1.0-2'}}</td>
                <td >{{totalAppArea | number:'1.0-2'}}</td>
                <td >{{targetArea | number:'1.0-2'}}</td>
            </tr>
            <tr>
                <td > Grand Total</td>
                <td></td>
                <td >{{grandVerfAppArea | number:'1.0-2'}}</td>
                <td >{{grandPendingArea | number:'1.0-2'}}</td>
                <td >{{grandIncompleteAppArea | number:'1.0-2'}}</td>
                <td >{{grandRejectedAppArea | number:'1.0-2'}}</td>
                <td >{{grandChangeRequestAppArea | number:'1.0-2'}}</td>
                <td >{{grandTotalAppArea | number:'1.0-2'}}</td>
                <td >{{grandTargetArea | number:'1.0-2'}}</td>
            </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>
    <p-dialog class="drilldown_details" [baseZIndex]="-100" header="Drill Down Vendor MI Area  Report Of {{name}} Application of {{vendorName}} "  [(visible)]="displayMaximizable" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-approved-incomplete-report  *ngIf="displayMaximizable" [drilldownDetails]="drilldownDetails"></app-drill-down-approved-incomplete-report>
    
   </p-dialog>
   <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Vendor MI Area Of Total Application of {{vendorName}} "  [(visible)]="displayMaximizable_totalApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-total-report  *ngIf="displayMaximizable_totalApp" [drilldownDetails]="drilldownDetails"></app-drill-down-total-report>
   
  </p-dialog>
  <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Vendor MI Area Report Of Pending Application of {{vendorName}} "  [(visible)]="displayMaximizable_pendingApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-pending-report  *ngIf="displayMaximizable_pendingApp" [drilldownDetails]="drilldownDetails"></app-drill-down-pending-report>
   
  </p-dialog>
  <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Vendor MI Area Report Of Rejected Application of {{vendorName}} "  [(visible)]="displayMaximizable_rejectedApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-rejected-report  *ngIf="displayMaximizable_rejectedApp" [drilldownDetails]="drilldownDetails"></app-drill-down-rejected-report>
   
  </p-dialog>